import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const AerialDemo = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, []);

  return (
    <>
      <div className="min-h-screen bg-gray-900">
        <Header />
        <motion.div
          className="container mx-auto px-4 py-8 max-w-6xl text-white"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex flex-col lg:flex-row items-center gap-8 mb-10">
            <div className="flex-1 space-y-4">
              <p className="uppercase tracking-[0.4em] text-sm text-blue-200">Demo interactivo</p>
              <h1 className="text-4xl md:text-5xl font-extrabold">Recorrido Aéreo 360°</h1>
              <p className="text-lg text-gray-200">
                Explora un ejemplo en vivo del tour inmersivo que ofrecemos para los desarrollos inmobiliarios. Usa el mouse o tu dedo para rotar, acercar y entender el contexto urbano completo desde el aire.
              </p>
              <Link
                to="/tours-virtuales"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-blue-700 font-semibold shadow-lg hover:bg-blue-50 transition-colors"
              >
                <ArrowLeftCircle className="w-5 h-5" />
                Volver a tours virtuales
              </Link>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-white/10">
            <iframe
              src="/recorrido-aereo-1-frame/"
              className="w-full h-[75vh] md:h-[85vh] transition-all duration-300"
              title="Recorrido Aéreo 360"
              loading="lazy"
              allowFullScreen
            />
            <div className="absolute bottom-4 right-4 z-20 bg-black/60 px-4 py-2 rounded-full text-sm text-white/80">
              Demo: Recorrido Aéreo 1
            </div>
          </div>
        </motion.div>
      </div>
      <Footer />
    </>
  );
};

export default AerialDemo;
